import { render, staticRenderFns } from "./mainPartEdit.vue?vue&type=template&id=3b545e0a&scoped=true&"
import script from "./mainPartEdit.vue?vue&type=script&lang=js&"
export * from "./mainPartEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b545e0a",
  null
  
)

export default component.exports